// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"232":"29ef308f","453":"28b6b97b"}[chunkId] + ".chunk.js";
};